import { Container, Link, Stack, Text } from "basis";
import { getRegional } from "library/getRegional";

function RelayService() {
  return (
    <Container bg="secondary.lightBlue.t25" padding="4">
      <Container bg="white" padding="6">
        <Stack gap="4">
          <Text as="h4" textStyle="heading5">
            {getRegional("relayServiceTitle")}
          </Text>
          <Text>
            Hearing or speech impaired? Please contact us through the{" "}
            {getRegional("relayServiceTitle")}.
          </Text>
          <Link href={getRegional("relayServiceLink")} newTab>
            Learn more
          </Link>
        </Stack>
      </Container>
    </Container>
  );
}

export { RelayService };
